/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Commands } from 'bridge-commands/commands';
import { Types } from 'bridge-commands/types';

export interface PluginItem {
    name?: string;
    loaded: boolean;
}

export enum PluginLoadStatus {
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    TIMEDOUT = 'TIMEDOUT',
    UNKNOWN = 'UNKNOWN'
}

export interface PluginLoadInfo {
    loadStatus: PluginLoadStatus;
    loadDurationMs: number;
}

@Injectable()
export class Plugins {
    mandatoryModuleNames: string[];
    optionalModulesNames: string[];
    pluginTimeout?: number;
}

export import ModulesActiveNotificationReturn = Types.Common.Applicationcontrol.ModulesActiveNotificationReturn;
export import State1 = Types.Common.Applicationcontrol.State1;

export const SystemInfoPluginKey = Commands.Common.Systeminfo.GetSystemInfo.module;
